// **************************************************************************************

jQuery( document ).ready( electricThemeReady );

// **************************************************************************************

function electricThemeReady() {

	// Wrap selects with a wrapper div.
	jQuery( 'body:not(.wp-customizer):not(.wp-admin) select' ).wrap( '<div class="select-wrapper generated"></div>' );

	// Wrap blog-tag-carousel content with a wrapper div.
	jQuery( '.blog-tag-carousel figure' ).wrapAll( '<div class="blog-tag-carousel-wrapper generated"><div class="blog-tag-carousel-content generated"></div></div>' );

	// Turn any media with text blocks that contain links into links themselves.
	jQuery( '.wp-block-media-text:has(a)' )
		.addClass( 'has-link' )
		.on( 'click', function () {
			document.location.href = jQuery( this ).find( 'a' )[0].href;
		} );

}

// **************************************************************************************
